import { render, staticRenderFns } from "./paba-change-password.vue?vue&type=template&id=4914a66d&scoped=true&lang=pug"
import script from "./paba-change-password.vue?vue&type=script&lang=js"
export * from "./paba-change-password.vue?vue&type=script&lang=js"
import style0 from "./paba-change-password.vue?vue&type=style&index=0&id=4914a66d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4914a66d",
  null
  
)

export default component.exports